export default "<div id=\"ggg\" onclick=\"lh_openchatWindow()\">ggggggggggggggt</div>\r\n"